/**
 * Environment Configuration
 * 
 * Simple environment config for CSAS Platform
 * 
 * Environment Variables:
 *   VITE_API_URL - API endpoint
 *   VITE_APP_NAME - Application name
 *   VITE_APP_ENVIRONMENT - Environment: 'development' or 'production'
 *   VITE_APP_VERSION - Application version
 *   VITE_APP_DEBUG - Enable debug mode
 *   VITE_APP_LOG_LEVEL - Log level
 *   VITE_API_TIMEOUT - API request timeout
 */

export const env = {
  // API Configuration
  api: {
    baseUrl: import.meta.env.VITE_API_URL || 'http://localhost:8000',
    timeout: parseInt(import.meta.env.VITE_API_TIMEOUT) || 10000,
  },
  
  // App Configuration
  app: {
    name: import.meta.env.VITE_APP_NAME || 'CSAS Platform',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    environment: import.meta.env.VITE_APP_ENVIRONMENT || 'development',
  },
  
  // Feature Flags
  features: {
    // Authentication bypass for development/testing
    authBypass: import.meta.env.VITE_AUTH_BYPASS === 'true' || false,
  },
  
  // UI Configuration
  ui: {
    // Add UI configuration here as needed
  },
  
  // External Services
  services: {
    // Add external service configs here as needed
  },
  
  // Development Settings
  debug: {
    enabled: import.meta.env.VITE_APP_DEBUG === 'true',
    logLevel: import.meta.env.VITE_APP_LOG_LEVEL || 'info',
  },
  
  // Helper methods
  isDevelopment: () => env.app.environment === 'development',
  isProduction: () => env.app.environment === 'production',
};

export default env;
